import { makeAutoObservable } from 'mobx';

export class ManagementStore {
  selectedTab = 0;
  jobQueueSearch = '';

  constructor() {
    makeAutoObservable(this);
  }

  setSelectedTab(tab: number) {
    this.selectedTab = tab;
  }

  setJobQueueSearch(term: string) {
    this.jobQueueSearch = term;
  }

  reset() {
    this.selectedTab = 0;
    this.jobQueueSearch = '';
  }
}

export const managementStore = new ManagementStore();
